module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("May I Have the Envelope, Please!")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A survey taken in Britain, France, and Germany in February 2002 found that one in nine people admits to sending themselves Valentine’s Day cards so he or she will get at least one. Of the remaining eight, one out of every three receives a card from his or her own children and one in ten steals them from someone else in the house."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center02"
  }, [_vm._v("A woman in Madrid, Spain, was shocked to discover that after five years of marriage, whenever her husband told her he was on a business trip he was actually taking "), _c('span', {
    staticClass: "big1"
  }, [_vm._v("mass.")]), _vm._v(" When she filed for divorce, Sandra Vega Martínez discovered that her husband, Jorge Barange, wasn’t a businessman as he had told her. He was, in fact, a "), _c('span', {
    staticClass: "big1"
  }, [_vm._v("Catholic priest.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399cdac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c12_r1.vue
// module id = 108
// module chunks = 0